(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('EquipeController', EquipeController);

    EquipeController.$inject = ['$scope', '$state', 'Equipe', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function EquipeController ($scope, $state, Equipe, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.remover = remover;
        
        loadAll();

        function loadAll () {
            Equipe.query({
                page: 0,
                size: 99
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.equipes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover essa Equipe?", "warning", function () {
                Equipe.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "A Equipe foi removida!");
                        loadAll();
                    });
            });
        }
        
    }
})();
